import { render, staticRenderFns } from "./MultiSelectQuestion.vue?vue&type=template&id=144840b2&scoped=true&"
import script from "./MultiSelectQuestion.vue?vue&type=script&lang=js&"
export * from "./MultiSelectQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectQuestion.vue?vue&type=style&index=0&id=144840b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144840b2",
  null
  
)

export default component.exports